import ActionsColumn from './ActionsColumn'

export const options = {
  computed: {
    options() {
      return {
        columnDefs: [
          {
            headerName: 'Product',
            field: 'name',
            sort: 'asc',
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/products/${params.data.id}`,
                newTab: true
              }
            }
          },

          {
            headerName: 'Title list status',
            field: 'title_list_status'
          },

          {
            headerName: 'Actions',
            sortable: false,
            resizable: false,
            lockVisible: true,
            cellRendererFramework: ActionsColumn
          }
        ]
      }
    }
  }
}
